import axios from "axios";
import React, { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import { baseurl } from "../../constant";
import Loading from "../../loading";
const UpiCollectionCharges = () => {
  const [data, setdata] = useState();
  const [err, seterr] = useState();
  const [datalength, setdatalength] = useState();

  const token = localStorage.getItem("authToken");

  const getdata = async () => {
    try {
      const result = await axios.post(baseurl + "myUpiCommisionAuth", {
        token: token,
      });

      await setdata(result.data.data);
      setdatalength(result.data.data.length);
    } catch (err) {
      seterr(err);
    }
  };
  useEffect(() => {
    getdata();
  }, []);

  return (
    <>
      <div className="card shadow mb-4">
        <form
          action="https://www.payol.in/admin/master/saveAEPSCommission"
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        >
          <input type="hidden" name="method" value="post" />
          <div className="card-header py-3">
            <div className="row">
              <div className="col-sm-8">
                <h4>
                  <b>My UPI Collection Commission</b>
                </h4>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive" id="dmr-comm-block">
              <table
                className="table table-bordered table-striped"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Service</th>
                    <th>Start Range</th>
                    <th>End Range</th>
                    <th>Commision</th>
                    <th>Is Flat ?</th>
                    <th>Is Surcharge ?</th>
                  </tr>
                </thead>

                {datalength > 0 ? (
                  <tbody>
                    {data.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>UPI</td>
                        <td>{item.start_range}</td>
                        <td>{item.end_range}</td>
                        <td>{item.commission}</td>

                        {item.is_flat == 0 && (
                          <td>
                            <font color="red">No</font>
                          </td>
                        )}
                        {item.is_flat == 1 && (
                          <td>
                            <font color="green">yes</font>
                          </td>
                        )}

                        {item.is_surcharge == 0 && (
                          <td>
                            <font color="red">no</font>
                          </td>
                        )}
                        {item.is_surcharge == 1 && (
                          <td>
                            <font color="green">yes</font>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tr>
                    <th colspan="11" style={{ textAlign: "center" }}>
                      No matching records found
                    </th>
                  </tr>
                )}
                <tfoot>
                  <tr>
                    <th>#</th>
                    <th>Service</th>
                    <th>Start Range</th>
                    <th>End Range</th>
                    <th>Commision</th>
                    <th>Is Flat ?</th>
                    <th>Is Surcharge ?</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default UpiCollectionCharges;
